import * as React from 'react';
import './card.scss';
import { cn } from '../../utils';
import { Arrow } from 'rcd-cpp-ui/ui/icon';

type Props = {
  header?: string;
  expandable?: boolean;
  collapsed?: boolean;
  selected?: boolean;
  disabled?: boolean;
  onSelect?: () => any;
  children: any;
};

export const Card = ({
  header,
  expandable,
  children,
  collapsed,
  onSelect,
  selected,
  disabled
}: Props) => {
  const [isExpanded, setExpanded] = React.useState(!collapsed);
  const [isSelected, setSelected] = React.useState(!!selected);
  React.useEffect(() => {
    if (selected !== undefined) {
      setSelected(selected);
    }
  }, [selected]);
  return (
    <div
      className={cn('card', {
        ['card-expandable']: expandable,
        ['card-selectable']: !!onSelect,
        ['card-selected']: isSelected,
        ['card-disabled']: !!disabled
      })}
      onClick={
        disabled
          ? null
          : () => {
              if (onSelect) {
                if (selected === undefined) setSelected(true);
                onSelect();
              }
            }
      }
    >
      {!header && !!onSelect ? null : (
        <div
          className="card-header"
          onClick={
            disabled
              ? null
              : () => {
                  if (expandable) setExpanded(!isExpanded);
                }
          }
        >
          {header}
          {expandable && (
            <div className="card-expand-icon">
              <Arrow type="solid" direction={isExpanded ? 'up' : 'down'} />
            </div>
          )}
        </div>
      )}
      {isExpanded && <div className="card-body">{children}</div>}
    </div>
  );
};
